export default __webpack_public_path__ + "static/media/Poppins-ExtraLight.a05f3b38.ttf";